import React, { useState } from "react";
import { StyleSheet, TouchableOpacity, View } from "react-native";
import Play from "@assets/svg/Play";
import Image from "@components/common/Image";
import VideoPlayer from "@components/VideoPlayer";
import metrics from "@constants/metrics";
import useGetVideoTime from "../../utils/useGetVideoTime";
import handleCMSNavigation from "../../utils/handleCMSNavigation";
import parseTemplate from "../../utils/parseTemplate";
import { shareOnWhatsapp } from "../../utils/shareEntity";
import VideoModal from "../VideoPlayer/VideoModal";
import BannerSkeleton from "@components/CMS/Skeleton/BannerSkeleton";
import { OTHER_EVENTS } from "../../constants/analyticsEventsCT";

const NxMBanner = (props) => {
  const {
    image_link = "",
    columns = null,
    link = "",
    link_type = "",
    // sharingTemplate: { image_link: sharing_image_link = "", template = "" },
    sharingLink = "",
    video_link = "",
    cms_item_id = "",
    image_dimension_height = 1,
    image_dimension_width = 1,
    trackEvent = () => {},
  } = props;

  const [show, setShow] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [loading, setLoading] = useState(true);

  const handleBannerPress = async () => {
    setShow(false);
    handleCMSNavigation(link, link_type);
    if (typeof trackEvent === "function") {
      trackEvent(OTHER_EVENTS.BANNER_CLICKED, {
        cms_item_id: props.cms_item_id,
        sub_type: "NXM Banner",
        cms_title: props.title_ref,
      });
    }
  };

  const aspectRatio = image_dimension_width / image_dimension_height;
  const width = metrics.screenWidth / columns;
  const imageHeight = width / aspectRatio;
  return columns && cms_item_id ? (
    <>
      {Boolean(video_link) && <VideoModal {...{ show, setShow, video_link }} />}
      <TouchableOpacity
        activeOpacity={1}
        onPress={handleBannerPress}
        style={[
          styles.relative,
          {
            width: metrics.screenWidth / columns,
            height: imageHeight,
          },
        ]}
      >
        {loading && !loaded && (
          <BannerSkeleton inner={true} height={imageHeight} />
        )}
        <Image
          source={{ uri: image_link, priority: Image.priority.high }}
          onLoadEnd={() => {
            setLoading(false);
            setLoaded(true);
          }}
          style={{
            width: metrics.screenWidth / columns,
            height: !loaded ? 0 : imageHeight,
          }}
        />
        {Boolean(video_link) && (
          <TouchableOpacity
            onPress={() => {
              handleBannerPress();
              setShow(!show);
            }}
            style={{
              ...StyleSheet.absoluteFill,
              backgroundColor: "rgba(0, 0, 0, .1)",
              overflow: "hidden",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <View
              style={{
                height: 50,
                width: 50,
                backgroundColor: "#fff",
                elevation: 6,
                borderRadius: 50 / 2,
                alignItems: "center",
                justifyContent: "center",
                paddingLeft: 5,
              }}
            >
              <Play />
            </View>
          </TouchableOpacity>
        )}
      </TouchableOpacity>
    </>
  ) : null;
};

const VideoContainer = ({
  video_link = "",
  handleBannerPress = () => {},
  ctaText = "Close",
}) => {
  const [state] = useGetVideoTime();

  return (
    <>
      <VideoPlayer videoLink={video_link} />

      {state.isCompleted && (
        <View style={{ position: "absolute", bottom: 20, left: 20, right: 20 }}>
          <Button
            style={{
              padding: 15,
            }}
            buttonWidth={"100%"}
            btnText={ctaText}
            buttonFontType="head1"
            height={56}
            borderRadius={10}
            onPress={handleBannerPress}
          />
        </View>
      )}
    </>
  );
};
export default NxMBanner;

const styles = StyleSheet.create({
  relative: {
    position: "relative",
  },
});
